import * as Actions from '../actions/calendarViewActions';
import {CalendarActionTypes, CalendarModes, CalendarModeTypes, CalendarViewType} from '../actions/calendarViewActions';
import locals from '../../lib/localStorage';


export type CalendarState = {
    viewType: CalendarViewType,
    currentView: CalendarModeTypes,
    isList: boolean
}

/**
 * Calculate the view name based on the
 * @param {CalendarViewType} viewType
 * @param {boolean} isList
 * @returns {CalendarModeTypes}
 */
const calculateView = (viewType: CalendarViewType, isList: boolean): CalendarModeTypes => {
    if (viewType === 'Day') return isList ? CalendarModes.ListDay : CalendarModes.TimeGridDay;
    else if (viewType === 'Week') return isList ? CalendarModes.ListWeek : CalendarModes.TimeGridWeek;
    else if (viewType === 'Month') return isList ? CalendarModes.ListMonth : CalendarModes.DayGridMonth;
    else throw new Error('Invalid view type');
}

// Default to month view (no list)
const viewType = locals.getString(locals.CAL_VIEW, 'Month') as CalendarViewType;
const isList = locals.getBoolean(locals.CAL_LIST, false);

/**
 * @type {CalendarState}
 */
const initialState: CalendarState = {
    viewType,
    isList: isList,
    currentView: calculateView(viewType, isList)
};

export type CalendarAction = {
    type: CalendarActionTypes,
    viewType: CalendarViewType,
    listMode: boolean,
    currentView: CalendarModeTypes
}

/**
 * @param {CalendarState} state
 * @param {CalendarAction} action
 * @returns {CalendarState}
 */
function calendarView(state: CalendarState = initialState, action: CalendarAction): CalendarState {
    const st = {...state};

    switch (action.type) {
        /**
         * Switch the view mode (day/week/month) and update state and local backup.
         */
        case Actions.SWITCH_VIEW_MODE: {
            st.viewType = action.viewType;
            st.currentView = calculateView(st.viewType, st.isList);

            locals.setString(locals.CAL_VIEW, action.viewType);

            return st;
        }

        /**
         * Switch the list mode (on=true) and update state and local backup.
         */
        case Actions.SWITCH_LIST_MODE: {
            st.isList = action.listMode;
            st.currentView = calculateView(st.viewType, st.isList);

            locals.setBoolean(locals.CAL_LIST, action.listMode);

            return st;
        }

        default: {
            return state;
        }
    }
}

export default calendarView;
